import { ReduxUtils } from '@dreamworld/pwa-helpers/redux-utils.js';
import { keyBy, get, isEmpty, forEach, findIndex } from "lodash-es";

import {
  CONNECTION_STATUS_CHANGED,
  MASTER_CHANGED,
  AUTH_STATUS_CHANGED,
  WRITE_DOCS_LOCAL_COMPLETED,
  WRITE_DOCS_LOCAL_FAILED,
  WRITE_DOCS_REMOTE_COMPLETED,
  WRITE_DOCS_REMOTE_FAILED,
  DOCS_UPDATED,
  QUERY,
  QUERY_UPDATE,
  QUERY_CANCEL,
  QUERY_SNAPSHOT,
  QUERY_METADATA,
  DESTROY,
  WRITE_DOCS_METADATA,
  LOCAL_WRITES,
  REVERT_LOCAL_WRITES
} from "./actions.js";

let localState;
try {
  localState = JSON.parse(window.localStorage.getItem('dreamdb.pendingFailedWrites')) || {};
} catch (error) {
  console.log(error);
}

const INITIAL_STATE = {
  ...localState
};

export default (state = INITIAL_STATE, action) => {
  let oState = { ...state };
  let oDocs, newState, oFailedWrites, oPendingWrites, query, queryResult, index, newValue, currDoc;

  switch (action.type) {

    case CONNECTION_STATUS_CHANGED:
      oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.connected`, action.connected);
      oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.connectionLost`, action.connectionLost);
      return ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.connectionError`, action.error);

    case MASTER_CHANGED:
      return ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.master`, action.master);

    case AUTH_STATUS_CHANGED:
      oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.auth`, action.status);
      return ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.authError`, action.error);

    case WRITE_DOCS_LOCAL_COMPLETED:
      oPendingWrites = get(oState, `couchdb-${action.couchdbName}.pendingWrites.${action.dbName}`);
      oFailedWrites = get(oState, `couchdb-${action.couchdbName}.failedWrites.${action.dbName}`) || {};
      oDocs = get(oState, `couchdb-${action.couchdbName}.docs-${action.dbName}`);

      let docs = Object.keys(action.docs);

      //remove from failedWrites if any
      forEach(docs, doc => {
        delete oFailedWrites[doc];
      });

      oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.failedWrites.${action.dbName}`, { ...oFailedWrites });

      //set pendingWrites
      let pendingWrites = {};

      docs.forEach((item) => {
        pendingWrites[item] = action.requestedAt;
      });

      newState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.pendingWrites.${action.dbName}`, { ...oPendingWrites, ...pendingWrites });

      //set docs
      return ReduxUtils.replace(newState, `couchdb-${action.couchdbName}.docs-${action.dbName}`, { ...oDocs, ...action.docs });

    case WRITE_DOCS_LOCAL_FAILED:
      return state;

    case WRITE_DOCS_REMOTE_COMPLETED:
      oPendingWrites = get(oState, `couchdb-${action.couchdbName}.pendingWrites.${action.dbName}`);

      //Remove from pendingWrites
      forEach(action.reqDocs, doc => {
        delete oPendingWrites[doc._id];
      });

      oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.pendingWrites.${action.dbName}`, { ...oPendingWrites });

      //Add failed docs in failedWrites
      if (!isEmpty(action.failedWrites)) {
        oFailedWrites = get(oState, `couchdb-${action.couchdbName}.failedWrites.${action.dbName}`) || {};

        forEach(action.failedWrites, doc => {
          oFailedWrites[doc.id] = { error: doc.error, reason: doc.reason };
        });

        oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.failedWrites.${action.dbName}`, { ...oFailedWrites });
      }

      return oState;

    case WRITE_DOCS_REMOTE_FAILED:
      //Remove from pendingWrites
      oPendingWrites = get(oState, `couchdb-${action.couchdbName}.pendingWrites.${action.dbName}`);

      forEach(action.reqDocs, doc => {
        delete oPendingWrites[doc._id];
      });

      oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.pendingWrites.${action.dbName}`, { ...oPendingWrites });

      //Add docs to failedWrites
      oFailedWrites = get(oState, `couchdb-${action.couchdbName}.failedWrites.${action.dbName}`) || {};

      forEach(action.reqDocs, doc => {
        oFailedWrites[doc._id] = { error: action.error.error || action.error.code, reason: action.error.reason || action.error.message };
      });

      return ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.failedWrites.${action.dbName}`, { ...oFailedWrites });

    case WRITE_DOCS_METADATA:
      oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.pendingWrites.${action.dbName}`, action.pendingDocs);
      return ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.failedWrites.${action.dbName}`, action.failedDocs);

    case DOCS_UPDATED:
      oDocs = get(oState, `couchdb-${action.couchdbName}.docs-${action.dbName}`) || {};

      //create object by id
      let updatedDocs = keyBy(action.docs, '_id');

      return ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.docs-${action.dbName}`, { ...oDocs, ...updatedDocs });

    case QUERY:
    case QUERY_UPDATE:
      let oldQuery = get(oState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}`);
      let oValue = get(oState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.value`);
      let oldMetadata = get(oState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.metadata`) || {};

      newState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}`, { ...oldQuery, ...action.query });

      //set old value of query
      newState = ReduxUtils.replace(newState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.value`, oValue);

      let docIdpath = (action.query.type === 'BY_ID' || action.query.type === 'BY_IDS') ? action.query.type === 'BY_ID' ? 'docId' : 'docIds' : '';

      //set docid if query type is `BY_ID` or `BY_IDS`.
      if (docIdpath) {
        newState = ReduxUtils.replace(newState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.${docIdpath}`, action.query[docIdpath]);
      }

      //update metadata
      return ReduxUtils.replace(newState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.metadata`, { ...oldMetadata, localInSync: false, inSync: false });

    case QUERY_CANCEL:
      return ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.live`, false);

    case QUERY_SNAPSHOT:
      oDocs = get(oState, `couchdb-${action.couchdbName}.docs-${action.dbName}`) || {};

      //set lastRefreshedAt
      newState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.lastRefreshedAt`, new Date().getTime());

      let isLiveQuery = action.query.once ? false : true;
      //set live
      newState = ReduxUtils.replace(newState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.live`, isLiveQuery);

      //set query value
      newState = ReduxUtils.replace(newState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.value`, action.value);
      
      //Set null value for document if query `BY_ID` and value is undefined
      if (action.query.type === 'BY_ID' && !action.value) {
        return ReduxUtils.replace(newState, `couchdb-${action.couchdbName}.docs-${action.dbName}.${action.query.docId}`, null);
      }

      let docsValue = action.value || [];

      //convert object to array
      if (!Array.isArray(docsValue) && action.query.type !== 'BY_IDS') {
        docsValue = [docsValue];
      }

      //create object by id
      if (Array.isArray(docsValue)) {
        docsValue = keyBy(docsValue, '_id');
      }

      //set docs
      return ReduxUtils.replace(newState, `couchdb-${action.couchdbName}.docs-${action.dbName}`, { ...oDocs, ...docsValue });

    case QUERY_METADATA:
      return ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${action.query.id}.metadata`, action.metadata);
    
    case LOCAL_WRITES:
    case REVERT_LOCAL_WRITES:
      forEach(action.docs, (newDoc) => {
        currDoc = get(oState, `couchdb-${action.couchdbName}.docs-${action.dbName}.${newDoc._id}`);

        if (!currDoc) {
          return;
        }
        
        oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.docs-${action.dbName}.${newDoc._id}`, newDoc);

        forEach(action.queryIds, (queryId) => {
          query = get(oState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${queryId}`);

          if (query.type !== "FIND" && query.type !== "VIEW") {
            return;
          }

          queryResult = get(query, `value`, []);
          index = findIndex(queryResult, (queryDoc) => queryDoc._id === newDoc._id);

          if (index !== -1) {
            newValue = [];

            forEach(queryResult, (doc, _index) => {
              if (index === _index) {
                newValue.push(newDoc);
                return;
              }

              newValue.push(doc);
            });

            oState = ReduxUtils.replace(oState, `couchdb-${action.couchdbName}.queries-${action.dbName}.${queryId}.value`, newValue);
          }
        }); 
      });

      return oState;

    case DESTROY:
      return ReduxUtils.replace(oState, `couchdb-${action.couchdbName}`, {});

    default:
      return state;
  }
};
